
















import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
@Component({
  name: 'MainTitle',
  components: { Chart }
})
export default class extends Vue {
  // @Prop({ default: '#00B66C' }) private color!: string
  @Prop({ default: 'orange' }) private type!: string
  @Prop() private normData!: any
  @Prop() private data!: any
  @Prop() private names!: any
  @Prop({}) private dataList!: any

  private chartId: string = ''
  private colorMap = {
    'green': '#00B66C',
    'orange': '#FF9B6F'
  }
  private subColorMap = {
    'green': '#A0D1BD',
    'orange': '#FFE0D2'
  }
  private areaColorMap = {
    'green': 'rgba(0, 182, 108, 0.23)',
    'orange': 'rgba(251, 131, 77, 0.43)'
  }
  private richStyle = {}

  private option: any = {
    color: [this.color],
    // animation: false,
    radar: {
      // startAngle: 60,
      splitNumber: 4,
      radius: '60%',
      splitArea: {
        areaStyle: {
          color: ['#FFFFFF']
        }
      },
      axisLine: {
        lineStyle: {
          color: this.subColor
        }
      },
      splitLine: {
        lineStyle: {
          color: [this.subColor, this.subColor, this.subColor, this.subColor, this.color]
        }
      },
      shape: 'circle',
      name: {
        textStyle: {
          color: '#999999',
          fontSize: 12
        },
        formatter: function(value, indicator) {
          if (value === '肌肉力量') {
            return `{a|${value}}`
          } else {
            return `${value}`
          }
        },
        rich: {
          a: {
            padding: [10, 0, 0, 0]
          }
        }
      },
      indicator: []
    },
    series: [
      {
        animation: false,
        name: '',
        type: 'radar',
        symbol: 'circle',
        // symbolSize: 5,
        label: {
          show: true,
          position: 'inside',
          formatter: function(params, ticket, callback) {
            return `{${params.dimensionIndex}|  }`
          },
          rich: {
            0: {
              backgroundColor: this.color,
              borderRadius: 50,
              borderColor: '#ffffff',
              borderWidth: 3,
              height: 10,
              width: 10
            },
            1: {
              backgroundColor: this.color,
              borderRadius: 50,
              borderColor: '#ffffff',
              borderWidth: 3,
              height: 10,
              width: 10
            },
            2: {
              backgroundColor: this.color,
              borderRadius: 50,
              borderColor: '#ffffff',
              borderWidth: 3,
              height: 10,
              width: 10
            },
            3: {
              backgroundColor: this.color,
              borderRadius: 50,
              borderColor: '#ffffff',
              borderWidth: 3,
              height: 10,
              width: 10
            },
            4: {
              backgroundColor: this.color,
              borderRadius: 50,
              borderColor: '#ffffff',
              borderWidth: 3,
              height: 10,
              width: 10
            },
            5: {
              backgroundColor: this.color,
              borderRadius: 50,
              borderColor: '#ffffff',
              borderWidth: 3,
              height: 10,
              width: 10
            },
            6: {
              backgroundColor: this.color,
              borderRadius: 50,
              borderColor: '#ffffff',
              borderWidth: 3,
              height: 10,
              width: 10
            }
          }
        },
        itemStyle: {
          color: 'none',
          borderColor: 'none',
          borderWidth: 3
        },
        areaStyle: {
          color: 'none'
        },
        lineStyle: {
          color: 'none'
        },
        data: [{
          value: []
        }]
      },
      {
        animation: false,
        name: '',
        type: 'radar',
        symbol: 'circle',
        label: {
          show: true,
          position: 'top',
          formatter: function(params, ticket, callback) {
            // const val = params.name[params.dimensionIndex] + '分'
            let index = params.dimensionIndex
            const val = params.name[index]
            return `{${index}|${val}}`
          },
          rich: this.richStyle
        },
        itemStyle: {
          color: 'none',
          borderColor: 'none',
          borderWidth: 3
        },
        areaStyle: {
          color: 'none'
        },
        lineStyle: {
          color: 'none'
        },
        data: [{
          value: [],
          name: []
        }]
      },
      {
        // animation: false,
        name: '',
        type: 'radar',
        symbol: 'none',
        itemStyle: {
          normal: {
            areaStyle: {
              color: this.areaColor
            }
          }
        },
        data: [{
          value: [],
          name: ''
        }],
        z: 10
      },
      {
        // animation: false,
        name: '',
        type: 'radar',
        symbol: 'none',
        itemStyle: {
          normal: {
            areaStyle: {
              color: '#FFFFFF'
            }
          }
        },
        lineStyle: {
          color: '#666666',
          type: 'dotted'
        },
        data: [{
          value: [],
          name: ''
        }]
      }]
  }
  get color() {
    return this.colorMap[this.type]
  }
  get subColor() {
    return this.subColorMap[this.type]
  }
  get areaColor() {
    return this.areaColorMap[this.type]
  }
  @Watch('dataList', { immediate: true, deep: true })
  onDataChange(val: any) {
    if (!this.dataList.length) return
    let length = this.dataList.length
    let style = {}
    if (length === 3) {
      style = {
        0: {
          color: this.color,
          padding: [-4, 0, 0, 0],
          fontWeight: 500,
          align: 'center',
          fontSize: 12
        },
        1: {
          color: this.color,
          padding: [-60, 78, 0, 0],
          fontWeight: 500,
          align: 'center',
          fontSize: 12
        },
        2: {
          color: this.color,
          padding: [-60, -110, 0, -35],
          fontWeight: 500,
          align: 'center',
          fontSize: 12
        }
      }
    } else if (length === 5) {
      style = {
        0: {
          color: this.color,
          padding: [20, 0, 0, 0],
          fontWeight: 500,
          fontSize: 12
        },
        1: {
          color: this.color,
          padding: [-40, 70, 0, 0],
          fontWeight: 500,
          fontSize: 12
        },
        2: {
          color: this.color,
          padding: [-70, 0, 0, -35],
          fontWeight: 500,
          fontSize: 12
        },
        3: {
          color: this.color,
          padding: [-70, 0, 0, 60],
          fontWeight: 500,
          fontSize: 12
        },
        4: {
          color: this.color,
          padding: [-40, 0, 0, 80],
          fontWeight: 500,
          fontSize: 12
        },
        5: {
          color: this.color,
          padding: [-50, 0, 0, 50],
          fontWeight: 500,
          fontSize: 12
        },
        6: {
          color: this.color,
          padding: [-30, 0, 0, 70],
          fontWeight: 500,
          fontSize: 12
        }
      }
    }
    this.option.series[1].label.rich = style

    let data = []
    let normData = []
    this.option.radar.indicator = []
    this.option.series[0].data[0].value = []
    this.option.series[1].data[0].value = []
    this.dataList.map((item: any) => {
      this.option.radar.indicator.push({
        name: item.name,
        max: 100
      })
      this.option.series[0].data[0].value.push(100)
      this.option.series[1].data[0].value.push(100)
      data.push(item.values[0])
      normData.push(item.values[1])
    })

    this.option.series[1].data[0].name = data
    this.option.series[2].data[0].value = data
    this.option.series[3].data[0].value = normData

    // this.option.series[0].data = this.dataList.map((item:any) => {
    //   item.value = item.values[0]
    //   return item
    // })
    this.$nextTick(() => {
      (this.$refs.chart as any).setOption(this.option)
    })
  }
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
  }
}
